import {
  EXPENSES_REQUESTS,
  CHECK_EXPENSES,
  CREDIT_CARDS_REQUEST,
  CREDIT_CARDS_LOADING,
  CREDIT_CARDS_SUCCESS,
  CREDIT_CARDS_ERROR,
  POST_NEW_CREDIT_CARD,
  NEW_CREDIT_CARD_SUCCESS,
  DELETE_CREDIT_CARD,
  DELETE_CREDIT_CARD_SUCCESS,
  EDIT_CREDIT_CARD,
  EDIT_CREDIT_CARD_SUCCESS,
  REQUEST_CREDIT_CARD_ITEM,
  CREDIT_CARD_ITEM_SUCCESS,
  ACCOUNTS_LOADING,
  ACCOUNTS_ERROR,
  REQUEST_CREDIT_ACCOUNTS,
  CREDIT_ACCOUNTS_SUCCESS,
  POST_NEW_CREDIT_ACCOUNT,
  NEW_CREDIT_ACCOUNT_SUCCESS,
  DELETE_CREDIT_ACCOUNT,
  DELETE_CREDIT_ACCOUNT_SUCCESS,
  EDIT_CREDIT_ACCOUNT,
  EDIT_CREDIT_ACCOUNT_SUCCESS,
  REQUEST_CREDIT_ACCOUNT_ITEM,
  REQUEST_CREDIT_ACCOUNT_ITEM_SUCCESS,
  REQUEST_INVESTMENT_ACCOUNTS,
  INVESTMENT_ACCOUNTS_SUCCESS,
  POST_NEW_INVESTMENT_ACCOUNT,
  NEW_INVESTMENT_ACCOUNT_SUCCESS,
  DELETE_INVESTMENT_ACCOUNT,
  DELETE_INVESTMENT_ACCOUNT_SUCCESS,
  EDIT_INVESTMENT_ACCOUNT,
  EDIT_INVESTMENT_ACCOUNT_SUCCESS,
  REQUEST_INVESTMENT_ACCOUNT_ITEM,
  REQUEST_INVESTMENT_ACCOUNT_ITEM_SUCCESS,
  REQUEST_CRYPTOCURRENCY_ACCOUNTS,
  CRYPTOCURRENCY_ACCOUNTS_SUCCESS,
  POST_NEW_CRYPTOCURRENCY_ACCOUNT,
  NEW_CRYPTOCURRENCY_ACCOUNT_SUCCESS,
  DELETE_CRYPTOCURRENCY_ACCOUNT,
  DELETE_CRYPTOCURRENCY_ACCOUNT_SUCCESS,
  EDIT_CRYPTOCURRENCY_ACCOUNT,
  EDIT_CRYPTOCURRENCY_ACCOUNT_SUCCESS,
  REQUEST_CRYPTOCURRENCY_ACCOUNT_ITEM,
  REQUEST_CRYPTOCURRENCY_ACCOUNT_ITEM_SUCCESS,
  REQUEST_FOOD_AND_HOUSING,
  POST_FOOD_AND_HOUSING,
  FOOD_AND_HOUSING_SUCCESS,
  FOOD_AND_HOUSING_LOADING,
  FOOD_AND_HOUSING_ERROR,
  REQUEST_TRANSPORTATION_AND_MEDICAL,
  POST_TRANSPORTATION_AND_MEDICAL,
  TRANSPORTATION_AND_MEDICAL_SUCCESS,
  TRANSPORTATION_AND_MEDICAL_LOADING,
  TRANSPORTATION_AND_MEDICAL_ERROR,
  REQUEST_OTHER_LIVING_EXPENSES,
  POST_OTHER_LIVING_EXPENSES,
  OTHER_LIVING_EXPENSES_SUCCESS,
  OTHER_LIVING_EXPENSES_LOADING,
  OTHER_LIVING_EXPENSES_ERROR,
  GET_ADDITIONAL_EXPENSES_FILES,
  GET_ADDITIONAL_FILES_SUCCESS,
  POST_ADDITIONAL_EXPENSES_FILES,
  POST_ADDITIONAL_FILES_SUCCESS,
  DELETE_ADDITIONAL_EXPENSES_FILES,
  DELETE_FILES_SUCCESS,
  FOOD_AND_HOUSING_CALCULATIONS_REQUEST,
  VEHICLE_CALCULATIONS_REQUEST,
  VEHICLE_CALCULATIONS_REQUEST_SUCCESS,
  TRANSPORT_CALCULATIONS_REQUEST,
  TRANSPORT_CALCULATIONS_REQUEST_SUCCESS,
  MEDICAL_CALCULATIONS_REQUEST,
  MEDICAL_CALCULATIONS_REQUEST_SUCCESS,
  DOWNLOAD_FILE,
} from '@/app/expenses/store/types';
import { LOGOUT, REFRESH_REQUEST } from '@/app/auth/store/types';

import { http } from '@/api';

export const actions = {
  [CHECK_EXPENSES]: ({ getters, dispatch }) => {
    const userId = getters.getUserId;
    dispatch(CREDIT_CARDS_REQUEST, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(EXPENSES_REQUESTS);
      }
    });
    dispatch(REQUEST_CREDIT_ACCOUNTS, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(EXPENSES_REQUESTS);
      }
    });
    dispatch(REQUEST_INVESTMENT_ACCOUNTS, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(EXPENSES_REQUESTS);
      }
    });
    dispatch(REQUEST_CRYPTOCURRENCY_ACCOUNTS, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(EXPENSES_REQUESTS);
      }
    });
    dispatch(REQUEST_FOOD_AND_HOUSING, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(EXPENSES_REQUESTS);
      }
    });
    dispatch(REQUEST_TRANSPORTATION_AND_MEDICAL, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(EXPENSES_REQUESTS);
      }
    });
    dispatch(REQUEST_OTHER_LIVING_EXPENSES, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(EXPENSES_REQUESTS);
      }
    });
    dispatch(GET_ADDITIONAL_EXPENSES_FILES, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(EXPENSES_REQUESTS);
      }
    });
  },
  [EXPENSES_REQUESTS]: ({ dispatch }, userId) => {
    dispatch(REFRESH_REQUEST)
      .then(() => {
        dispatch(CREDIT_CARDS_REQUEST, userId);
        dispatch(REQUEST_CREDIT_ACCOUNTS, userId);
        dispatch(REQUEST_INVESTMENT_ACCOUNTS, userId);
        dispatch(REQUEST_CRYPTOCURRENCY_ACCOUNTS, userId);
        dispatch(REQUEST_FOOD_AND_HOUSING, userId);
        dispatch(REQUEST_TRANSPORTATION_AND_MEDICAL, userId);
        dispatch(REQUEST_OTHER_LIVING_EXPENSES, userId);
        dispatch(GET_ADDITIONAL_EXPENSES_FILES, userId);

        return false;
      });
  },
  /* CreditCards */
  [CREDIT_CARDS_REQUEST]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(CREDIT_CARDS_LOADING);
    http.get(`/expenses/apps/${userId}/personal-credit-card`)
      .then((resp) => {
        commit(CREDIT_CARDS_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(CREDIT_CARDS_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_NEW_CREDIT_CARD]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(CREDIT_CARDS_LOADING);
    http.post(`/expenses/apps/${item.userId}/personal-credit-card`, item.newItem)
      .then((resp) => {
        commit(NEW_CREDIT_CARD_SUCCESS, resp);
        resolve(resp);
      })
      .catch((err) => {
        commit(CREDIT_CARDS_ERROR);
        reject(err);
      });
  })),
  [DELETE_CREDIT_CARD]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(CREDIT_CARDS_LOADING);
    http.delete(`/expenses/apps/${item.userId}/personal-credit-card/${item.id}`)
      .then((resp) => {
        commit(DELETE_CREDIT_CARD_SUCCESS, item.id);
        resolve(resp);
      })
      .catch((err) => {
        commit(CREDIT_CARDS_ERROR);
        reject(err);
      });
  })),
  [EDIT_CREDIT_CARD]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(CREDIT_CARDS_LOADING);
    http.put(`/expenses/apps/${item.userId}/personal-credit-card/${item.editedItemId}`, item.newItem)
      .then((resp) => {
        commit(EDIT_CREDIT_CARD_SUCCESS, item);
        resolve(resp);
      })
      .catch((err) => {
        commit(CREDIT_CARDS_ERROR);
        reject(err);
      });
  })),
  [REQUEST_CREDIT_CARD_ITEM]: ({ commit, dispatch }, item) => new Promise(((resolve, reject) => {
    commit(CREDIT_CARDS_LOADING);
    http.get(`/expenses/apps/${item.userId}/personal-credit-card/${item.itemId}`)
      .then((resp) => {
        commit(CREDIT_CARD_ITEM_SUCCESS, {
          item: resp.data,
          id: item.itemId,
        });
        resolve(resp);
      })
      .catch((err) => {
        commit(CREDIT_CARDS_ERROR);
        if (err.response.status !== 404) {
          if (err.response.status === 401) {
            dispatch(LOGOUT);
          } else {
            reject(err);
          }
        }
      });
  })),
  /* Credit Accounts */
  [REQUEST_CREDIT_ACCOUNTS]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(ACCOUNTS_LOADING);
    http.get(`/expenses/apps/${userId}/line-of-credit`)
      .then((resp) => {
        commit(CREDIT_ACCOUNTS_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(ACCOUNTS_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_NEW_CREDIT_ACCOUNT]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(ACCOUNTS_LOADING);
    http.post(`/expenses/apps/${item.userId}/line-of-credit`, item.newItem)
      .then((resp) => {
        commit(NEW_CREDIT_ACCOUNT_SUCCESS, resp);
        resolve(resp);
      })
      .catch((err) => {
        commit(ACCOUNTS_ERROR);
        reject(err);
      });
  })),
  [DELETE_CREDIT_ACCOUNT]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(ACCOUNTS_LOADING);
    http.delete(`/expenses/apps/${item.userId}/line-of-credit/${item.id}`)
      .then((resp) => {
        commit(DELETE_CREDIT_ACCOUNT_SUCCESS, item.id);
        resolve(resp);
      })
      .catch((err) => {
        commit(ACCOUNTS_ERROR);
        reject(err);
      });
  })),
  [EDIT_CREDIT_ACCOUNT]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(ACCOUNTS_LOADING);
    http.put(`/expenses/apps/${item.userId}/line-of-credit/${item.editedItemId}`, item.newItem)
      .then((resp) => {
        commit(EDIT_CREDIT_ACCOUNT_SUCCESS, item);
        resolve(resp);
      })
      .catch((err) => {
        commit(ACCOUNTS_ERROR);
        reject(err);
      });
  })),
  [REQUEST_CREDIT_ACCOUNT_ITEM]: ({ commit, dispatch }, item) => new Promise(((resolve, reject) => {
    commit(ACCOUNTS_LOADING);
    http.get(`/expenses/apps/${item.userId}/line-of-credit/${item.itemId}`)
      .then((resp) => {
        commit(REQUEST_CREDIT_ACCOUNT_ITEM_SUCCESS, {
          item: resp.data,
          id: item.itemId,
        });
        resolve(resp);
      })
      .catch((err) => {
        commit(ACCOUNTS_ERROR);
        if (err.response.status !== 404) {
          if (err.response.status === 401) {
            dispatch(LOGOUT);
          } else {
            reject(err);
          }
        }
      });
  })),
  /* Investment Accounts */
  [REQUEST_INVESTMENT_ACCOUNTS]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(ACCOUNTS_LOADING);
    http.get(`/expenses/apps/${userId}/investment-account`)
      .then((resp) => {
        commit(INVESTMENT_ACCOUNTS_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(ACCOUNTS_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_NEW_INVESTMENT_ACCOUNT]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(ACCOUNTS_LOADING);
    http.post(`/expenses/apps/${item.userId}/investment-account`, item.newItem)
      .then((resp) => {
        commit(NEW_INVESTMENT_ACCOUNT_SUCCESS, resp);
        resolve(resp);
      })
      .catch((err) => {
        commit(ACCOUNTS_ERROR);
        reject(err);
      });
  })),
  [DELETE_INVESTMENT_ACCOUNT]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(ACCOUNTS_LOADING);
    http.delete(`/expenses/apps/${item.userId}/investment-account/${item.id}`)
      .then((resp) => {
        commit(DELETE_INVESTMENT_ACCOUNT_SUCCESS, item.id);
        resolve(resp);
      })
      .catch((err) => {
        commit(ACCOUNTS_ERROR);
        reject(err);
      });
  })),
  [EDIT_INVESTMENT_ACCOUNT]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(ACCOUNTS_LOADING);
    http.put(`/expenses/apps/${item.userId}/investment-account/${item.editedItemId}`, item.newItem)
      .then((resp) => {
        commit(EDIT_INVESTMENT_ACCOUNT_SUCCESS, item);
        resolve(resp);
      })
      .catch((err) => {
        commit(ACCOUNTS_ERROR);
        reject(err);
      });
  })),
  [REQUEST_INVESTMENT_ACCOUNT_ITEM]: ({ commit, dispatch },
    item) => new Promise(((resolve, reject) => {
    commit(ACCOUNTS_LOADING);
    http.get(`/expenses/apps/${item.userId}/investment-account/${item.itemId}`)
      .then((resp) => {
        commit(REQUEST_INVESTMENT_ACCOUNT_ITEM_SUCCESS, {
          item: resp.data,
          id: item.itemId,
        });
        resolve(resp);
      })
      .catch((err) => {
        commit(ACCOUNTS_ERROR);
        if (err.response.status !== 404) {
          if (err.response.status === 401) {
            dispatch(LOGOUT);
          } else {
            reject(err);
          }
        }
      });
  })),
  /* Cryptocurrency Accounts */
  [REQUEST_CRYPTOCURRENCY_ACCOUNTS]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(ACCOUNTS_LOADING);
    http.get(`/expenses/apps/${userId}/cryptocurrency-account`)
      .then((resp) => {
        commit(CRYPTOCURRENCY_ACCOUNTS_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(ACCOUNTS_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_NEW_CRYPTOCURRENCY_ACCOUNT]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(ACCOUNTS_LOADING);
    http.post(`/expenses/apps/${item.userId}/cryptocurrency-account`, item.newItem)
      .then((resp) => {
        commit(NEW_CRYPTOCURRENCY_ACCOUNT_SUCCESS, resp);
        resolve(resp);
      })
      .catch((err) => {
        commit(ACCOUNTS_ERROR);
        reject(err);
      });
  })),
  [DELETE_CRYPTOCURRENCY_ACCOUNT]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(ACCOUNTS_LOADING);
    http.delete(`/expenses/apps/${item.userId}/cryptocurrency-account/${item.id}`)
      .then((resp) => {
        commit(DELETE_CRYPTOCURRENCY_ACCOUNT_SUCCESS, item.id);
        resolve(resp);
      })
      .catch((err) => {
        commit(ACCOUNTS_ERROR);
        reject(err);
      });
  })),
  [EDIT_CRYPTOCURRENCY_ACCOUNT]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(ACCOUNTS_LOADING);
    http.put(`/expenses/apps/${item.userId}/cryptocurrency-account/${item.editedItemId}`, item.newItem)
      .then((resp) => {
        commit(EDIT_CRYPTOCURRENCY_ACCOUNT_SUCCESS, item);
        resolve(resp);
      })
      .catch((err) => {
        commit(ACCOUNTS_ERROR);
        reject(err);
      });
  })),
  [REQUEST_CRYPTOCURRENCY_ACCOUNT_ITEM]: ({ commit, dispatch },
    item) => new Promise(((resolve, reject) => {
    commit(ACCOUNTS_LOADING);
    http.get(`/expenses/apps/${item.userId}/cryptocurrency-account/${item.itemId}`)
      .then((resp) => {
        commit(REQUEST_CRYPTOCURRENCY_ACCOUNT_ITEM_SUCCESS, {
          item: resp.data,
          id: item.itemId,
        });
        resolve(resp);
      })
      .catch((err) => {
        commit(ACCOUNTS_ERROR);
        if (err.response.status !== 404) {
          if (err.response.status === 401) {
            dispatch(LOGOUT);
          } else {
            reject(err);
          }
        }
      });
  })),
  /* Food and Housing */
  [REQUEST_FOOD_AND_HOUSING]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(FOOD_AND_HOUSING_LOADING);
    http.get(`/expenses/apps/${userId}/food-housing`)
      .then((resp) => {
        commit(FOOD_AND_HOUSING_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(FOOD_AND_HOUSING_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_FOOD_AND_HOUSING]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(FOOD_AND_HOUSING_LOADING);
    http.put(`/expenses/apps/${item.userId}/food-housing`, item.newItem)
      .then((resp) => {
        commit(FOOD_AND_HOUSING_SUCCESS, JSON.parse(resp.config.data));
        resolve(resp);
      })
      .catch((err) => {
        commit(FOOD_AND_HOUSING_ERROR);
        reject(err);
      });
  })),
  /* Transportation and Medical */
  [REQUEST_TRANSPORTATION_AND_MEDICAL]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(TRANSPORTATION_AND_MEDICAL_LOADING);
    http.get(`/expenses/apps/${userId}/transportation-medical`)
      .then((resp) => {
        commit(TRANSPORTATION_AND_MEDICAL_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(TRANSPORTATION_AND_MEDICAL_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_TRANSPORTATION_AND_MEDICAL]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(TRANSPORTATION_AND_MEDICAL_LOADING);
    http.put(`/expenses/apps/${item.userId}/transportation-medical`, item.newItem)
      .then((resp) => {
        commit(TRANSPORTATION_AND_MEDICAL_SUCCESS, JSON.parse(resp.config.data));
        resolve(resp);
      })
      .catch((err) => {
        commit(TRANSPORTATION_AND_MEDICAL_ERROR);
        reject(err);
      });
  })),
  /* Other living expenses */
  [REQUEST_OTHER_LIVING_EXPENSES]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(OTHER_LIVING_EXPENSES_LOADING);
    http.get(`/expenses/apps/${userId}/other`)
      .then((resp) => {
        commit(OTHER_LIVING_EXPENSES_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(OTHER_LIVING_EXPENSES_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_OTHER_LIVING_EXPENSES]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(OTHER_LIVING_EXPENSES_LOADING);
    http.put(`/expenses/apps/${item.userId}/other`, item.newItem)
      .then((resp) => {
        commit(OTHER_LIVING_EXPENSES_SUCCESS, JSON.parse(resp.config.data));
        resolve(resp);
      })
      .catch((err) => {
        commit(OTHER_LIVING_EXPENSES_ERROR);
        reject(err);
      });
  })),
  [GET_ADDITIONAL_EXPENSES_FILES]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(OTHER_LIVING_EXPENSES_LOADING);
    http.get(`/expenses/apps/${userId}/other-expenses-file`)
      .then((resp) => {
        commit(GET_ADDITIONAL_FILES_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(OTHER_LIVING_EXPENSES_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_ADDITIONAL_EXPENSES_FILES]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(OTHER_LIVING_EXPENSES_LOADING);
    http.post(`/expenses/apps/${item.userId}/other-expenses-file`, item.formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((resp) => {
        commit(POST_ADDITIONAL_FILES_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(OTHER_LIVING_EXPENSES_ERROR);
        reject(err);
      });
  })),
  [DELETE_ADDITIONAL_EXPENSES_FILES]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(OTHER_LIVING_EXPENSES_LOADING);
    http.delete(`/expenses/apps/${item.userId}/other-expenses-file/${item.id}`)
      .then((resp) => {
        commit(DELETE_FILES_SUCCESS, item.id);
        resolve(resp);
      })
      .catch((err) => {
        commit(OTHER_LIVING_EXPENSES_ERROR);
        reject(err);
      });
  })),
  [FOOD_AND_HOUSING_CALCULATIONS_REQUEST]: ({ commit, dispatch },
    userId) => new Promise(((resolve, reject) => {
    commit(FOOD_AND_HOUSING_LOADING);
    http.get(`/expenses/apps/${userId}/calc-food-housing`)
      .then((resp) => {
        commit(FOOD_AND_HOUSING_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(FOOD_AND_HOUSING_ERROR);
        if (err.response.status !== 404) {
          if (err.response.status === 401) {
            dispatch(REFRESH_REQUEST);
          } else {
            reject(err);
          }
        }
      });
  })),
  [VEHICLE_CALCULATIONS_REQUEST]: ({ commit, dispatch },
    userId) => new Promise(((resolve, reject) => {
    commit(TRANSPORTATION_AND_MEDICAL_LOADING);
    http.get(`/expenses/apps/${userId}/calc-vehicle-operation`)
      .then((resp) => {
        commit(VEHICLE_CALCULATIONS_REQUEST_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(TRANSPORTATION_AND_MEDICAL_ERROR);
        if (err.response.status !== 404) {
          if (err.response.status === 401) {
            dispatch(REFRESH_REQUEST);
          } else {
            reject(err);
          }
        }
      });
  })),
  [TRANSPORT_CALCULATIONS_REQUEST]: ({ commit, dispatch },
    userId) => new Promise(((resolve, reject) => {
    commit(TRANSPORTATION_AND_MEDICAL_LOADING);
    http.get(`/expenses/apps/${userId}/calc-public-transportation`)
      .then((resp) => {
        commit(TRANSPORT_CALCULATIONS_REQUEST_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(TRANSPORTATION_AND_MEDICAL_ERROR);
        if (err.response.status !== 404) {
          if (err.response.status === 401) {
            dispatch(REFRESH_REQUEST);
          } else {
            reject(err);
          }
        }
      });
  })),
  [MEDICAL_CALCULATIONS_REQUEST]: ({ commit, dispatch },
    userId) => new Promise(((resolve, reject) => {
    commit(TRANSPORTATION_AND_MEDICAL_LOADING);
    http.get(`/expenses/apps/${userId}/calc-medical`)
      .then((resp) => {
        commit(MEDICAL_CALCULATIONS_REQUEST_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(TRANSPORTATION_AND_MEDICAL_ERROR);
        if (err.response.status !== 404) {
          if (err.response.status === 401) {
            dispatch(REFRESH_REQUEST);
          } else {
            reject(err);
          }
        }
      });
  })),
  // eslint-disable-next-line no-empty-pattern
  [DOWNLOAD_FILE]: ({}, file) => new Promise((resolve, reject) => {
    http.get(`/expenses/apps/${file.userId}/other-expenses-file/${file.id}`, {
      responseType: 'blob',
    }).then((resp) => {
      resolve(resp);
    }).catch((err) => {
      reject(err);
    });
  }),
};
